import React from "react";
import ReactDOM from "react-dom/client";
import "swiper/css";
import "./assets/css/main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Interceptor from "./interceptors/Interceptor";

const root = ReactDOM.createRoot(document.getElementById("root"));
Interceptor();
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
